import { whenPageLoaded } from './utils/event-listeners';
import whenElementIsInWindow from './utils/whenElementIsInWindow';

export default function lazyLoadAttribute(attribute) {
    function run() {
        [].slice.call(document.querySelectorAll(`[data-ll-${attribute}]`)).forEach(element => {
            whenElementIsInWindow(element, function () {
                if (element.dataset.llHasLoaded || element.dataset.llIsLoading) {
                    return;
                }

                if(element.dataset.llDeferMs) {
                    element.setAttribute('data-ll-is-loading', 'true');
                    setTimeout(load, element.dataset.llDeferMs);
                }
                else {
                    load();
                }

                function load() {
                    const pascalCaseAttribute = attribute.replace(
                        /(\w)(\w*)/g,
                        (g0, g1, g2) => g1.toUpperCase() + g2.toLowerCase(),
                    );
                    element.setAttribute(attribute, element.dataset[`ll${pascalCaseAttribute}`]);
                    element.setAttribute('data-ll-has-loaded', 'true');
                    element.removeAttribute(`data-ll-${attribute}`);
                }
            });
        });
    }

    whenPageLoaded(run);
}
